export default __webpack_public_path__ + "static/media/logo-text.feb72b47.svg";